import React, {useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import PageWrapper from '../../shared/pagewrapper/PageWrapper.js';
import PageTitle from '../../shared/pagetitle/PageTitle.js';
import Message from '../../shared/message/Message.js';
import PainelEstatisticas from '../components/PainelEstatisticas.jsx';
import useSWRFetch from '../../../hooks/useSWRFetch.js';
import {URL_ACOMPANHAMENTO_PROCESSOS} from '../../../constants/index.js';
import {containerPaper} from '../../../utils/styles.js';

const SWR_CONFIG_PROCESSOS = {revalidateOnFocus: false};
const PARAMS = {};
const INPUT_PROPS = {'aria-label': 'Processo de seleção'};

const useStyles = makeStyles(theme => ({
    ...containerPaper(theme),
    // No mobile o Select desce para baixo do título, ocupando a largura toda; no desktop o wrapper fixa a largura do fullWidth.
    tituloVisaoGeral: {
        flexWrap: 'wrap',
        gap: theme.spacing(1)
    },
    filtro: {
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            width: 400
        }
    }
}));

/*
 * Acompanhamento Estatístico (migrado do PrimeFaces, sem a visão de agendamentos): um Paper só, com a
 * Visão Geral (e o Select do processo de seleção à direita do título) e, abaixo, status, inscritos e situações,
 * evolução e período das inscrições, documentos e pendências e concorrência por curso. Programa do governo
 * mostra só status e selecionados.
 */
export default function PageAcompanhamento() {
    const classes = useStyles();
    const processos = useSWRFetch(URL_ACOMPANHAMENTO_PROCESSOS, PARAMS, SWR_CONFIG_PROCESSOS);
    const [idSelecionado, setIdSelecionado] = useState('');

    // Sem escolha do usuário, vale o processo mais novo (a lista vem do mais novo para o mais antigo).
    const idProcessoSeletivo = idSelecionado || (processos && processos.length ? processos[0].id : '');

    return (
        <PageWrapper>
            <PageTitle title='Acompanhamento Estatístico'/>
            {processos && !processos.length ? (
                <Message type='info'>Nenhum processo de seleção cadastrado.</Message>
            ) : (
                <Paper className={classes.containerPaper}>
                    <PageTitle title='Visão Geral' className={classes.tituloVisaoGeral}>
                        <div className={classes.filtro}>
                            <FormControl fullWidth>
                                <Select
                                    value={idProcessoSeletivo}
                                    onChange={event => setIdSelecionado(event.target.value)}
                                    displayEmpty
                                    inputProps={INPUT_PROPS}>
                                    <MenuItem value='' disabled><em>Selecione...</em></MenuItem>
                                    {(processos || []).map(processo => (
                                        <MenuItem key={processo.id} value={processo.id}>
                                            {processo.descricao}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </div>
                    </PageTitle>
                    {idProcessoSeletivo && (
                        <PainelEstatisticas idProcessoSeletivo={idProcessoSeletivo}/>
                    )}
                </Paper>
            )}
        </PageWrapper>
    );
}
